import { cn } from '@/lib/utils';
import AutoPilotStatusLogo from '@/assets/autopilotStatusLogo.png'
import AutoPilotStatusLogoError from '@/assets/autopilotStatusLogoError.png'
import AutoPilotStatusLogoOff from '@/assets/autopilotStatusLogoOff.png'

type Status = 'active' | 'inactive' | 'alarm';

interface StatusBadgeProps {
  status: Status;
  isAlarm?: boolean
  className?: string;
}

const statusConfig = {
  active: {
    color: 'bg-alto-blue',
    textColor: 'text-white',
    logo: AutoPilotStatusLogo,
  },
  inactive: {
    color: 'bg-[#F0F0F0]',
    textColor: 'text-[#B4B4B4]',
    logo: AutoPilotStatusLogoOff,
  },
  alarm: {
    color: 'bg-heatmap-hot',
    textColor: 'text-danger',
    logo: AutoPilotStatusLogoError,
  }
} as const;

export function AutopilotState({ status, isAlarm, className }: StatusBadgeProps) {
  let stateKey = status
  if (isAlarm) {
    stateKey = 'alarm'
  }
  const config = statusConfig[stateKey];

  return (
    <div className="flex items-center justify-center w-full">
      <div className={cn("flex w-[54px] h-[18px] rounded-[5px] items-center justify-center", config.color, config.textColor, className)}>
        <img src={config.logo} className="w-[10px] h-[10px] mr-[3px]" />
        <span className={cn("paragraph-8 capitalize font-inter whitespace-nowrap")} style={{ fontFamily: 'Inter, sans-serif !important' }}>
          {status}
        </span>
      </div>
    </div>
  );
}